export enum Status {
  Submitted = 'SUBMITTED',
  Denied = 'DENIED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Started = 'STARTED',
  Reopened = 'REOPENED',
  OnHold = 'ONHOLD',
}
